import { FileText } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useIdCardDownload } from "@/hooks/useIdCardDownload";

interface IdCard {
  id: string;
  file_path: string;
  uploaded_at: string;
}

export const IdCardsList = ({ idCards = [] }: { idCards?: IdCard[] }) => {
  const { downloadIdCard } = useIdCardDownload();

  if (!idCards || idCards.length === 0) {
    return (
      <Card className="p-8 bg-gray-50 border-dashed">
        <p className="text-center text-muted-foreground text-lg">No ID cards found.</p>
      </Card>
    );
  }

  return (
    <div className="grid gap-4">
      {idCards.map((card) => (
        <Card 
          key={card.id} 
          className="p-6 hover:shadow-md transition-shadow duration-200 bg-white"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-primary/10 rounded-full">
                <FileText className="h-6 w-6 text-primary" />
              </div>
              <div>
                <p className="font-medium text-lg text-gray-900">ID Card</p>
                <p className="text-sm text-muted-foreground">
                  Uploaded {new Date(card.uploaded_at).toLocaleDateString()}
                </p>
              </div>
            </div>
            <Button 
              variant="outline"
              onClick={() => downloadIdCard(card.file_path)}
              className="hover:bg-primary/10 hover:text-primary transition-colors"
            >
              Download
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
};